import { List, ListItem, ListItemText, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => ({
    root: {
        maxHeight: '60vh'
    },
    listItem: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.background.default
        }
    }
}));

function NotificationList({
    notifications,
    onClickNotification,
    className,
    ...rest
}) {
    const classes = useStyles();

    const getTitle = (event, Title) => {
 
          var Deger = Title;
          return <Typography color="primary" variant="h6">
            {Deger}
          </Typography>;
  
    }
    return (
        <List
            {...rest}
            className={clsx(classes.root, className)}
            disablepadding
        >
            {notifications.map((notification, i) => (
                <ListItem
                    className={classes.listItem}
                    divider={i < notifications.length - 1}
                    key={notification.ID}
                    onClick={() => onClickNotification(notification)}
                >
                    <ListItemText
                        primary={getTitle(notification, notification.Title)}
                        primaryTypographyProps={{ variant: 'body1' }}
                        secondary={
                            <React.Fragment>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    className={classes.inline}
                                    color="textPrimary"
                                >
                                    {notification.Body}
                                </Typography>
                            </React.Fragment>
                        }
                    />
                    <ArrowForwardIcon className={classes.arrowForwardIcon} />
                </ListItem>
            ))}
        </List>
    );
}

NotificationList.propTypes = {
    className: PropTypes.string,
    notifications: PropTypes.array.isRequired,
    onClickNotification: PropTypes.func
};

export default NotificationList;
